import { Kitchen } from '../kitchen.class';

export const getDescriptionCfn = (kitchen: Kitchen, privateDescription: string): string => {
	let description = privateDescription;
	// console.log('Getting description for kitchen: ', description);

	if (privateDescription === null || privateDescription.trim() === '') {
		const angleMap = { 0: 0, 45: 0, 90: 0, 135: 0, 180: 0, 225: 0, 270: 0, 315: 0 };
		kitchen.design.islands.children.forEach((island) => {
			const angle = island.axis.y;
			angleMap[angle] += 1;
		});

		// do we have a L or U shaped kitchen?
		if (angleMap[0] >= 1 && (angleMap[90] >= 1 || angleMap[270] >= 1)) {
			let isUShaped = false;
			if (angleMap[90] >= 1 && angleMap[270] >= 1) {
				isUShaped = true;
				description = 'U-Shaped';
			} else if (angleMap[90] >= 1) {
				description = 'L-Shaped Bar Right';
			} else if (angleMap[279] >= 1) {
				description = 'L-Shaped Bar Left';
			}

			if (angleMap[45] >= 1 && angleMap[315] >= 1) {
				description += ' with Corners';
			} else if (angleMap[45] >= 1) {
				description += ` with ${isUShaped ? 'Right' : ''} Corner`;
			} else if (angleMap[315] >= 1) {
				description += ` with ${isUShaped ? 'Left' : ''} Corner`;
			}
		// do we have
		} else if (angleMap[0] >= 1 && angleMap[180] >= 1) {
			description = 'Galley';
		} else if (angleMap[0] >= 1) {
			description = 'Linear';
		} else {
			// console.log('Unknown kitchen shape', angleMap, kitchen.design.islands.children);
			description = 'No description available';
		}
	}

	return description;
};
